// @ts-nocheck
import styled from 'styled-components'

const SpaceTeam = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    width: 100%;
    height: 100%;
`;

const SpaceWrestler = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 50%;
    height: 50%;
`;

const SpaceAvatar = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 70%;

    &.left {
        justify-content: flex-end;
    }

    &.right {
        justify-content: flex-start;
    }

    &.center {
        justify-content: center;
    }

    & img.avatar-wrestler{
        width: 50%;
        height: 100%;
        object-fit: cover;
        object-position: top;
        border: ${props => props.withWinner ? props.isWinner ? '1.5px solid gold' : '1px solid white' : '1px solid white'};
    }
`;

const SpaceName = styled.div`
    display: flex;
    align-items: center;
    width: 100%;
    height: 30%;

    &.left {
        justify-content: flex-end;
    }

    &.right {
        justify-content: flex-start;
    }

    &.center {
        justify-content: center;
    }

    & h6.name-wrestler{
        font-size: 5px;
        color: white;
        text-align: center;
        margin: 0;
        padding: 0 2px;
        font-weight: 500;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
`;


function RenderTeamWhenFourInSpace({ team, side, withWinner = false }) {
  return (
    <SpaceTeam className={`space-team ${side} baubau`}>
        {team.map((wrestler, index) => (
            <SpaceWrestler className='space-wrestler' key={index}>
                {/* Se index è 0 o 2, allora className è left, se 1 o 3 è right */}
                <SpaceAvatar className={`space-avatar ${index === 0 || index === 2 ? 'left' : index === 1 || index === 3 ? 'right' : 'center'}`}
                 withWinner={withWinner}
                 isWinner={wrestler.pivot.is_winner}
                >
                    <img src={process.env.REACT_APP_STORAGE_URL + wrestler.avatar_path} alt={wrestler.name} className='avatar-wrestler' />
                </SpaceAvatar>
                <SpaceName className={`space-name ${index === 0 || index === 2 ? 'left' : index === 1 || index === 3 ? 'right' : 'center'}`}>
                    <h6 className='name-wrestler'>{wrestler.name}</h6>
                </SpaceName>
            </SpaceWrestler>
        ))}
    </SpaceTeam>
  )
}

export default RenderTeamWhenFourInSpace